export enum PhotographyPotential {
  DONT_CARE = 'dont-care',
  CRUCIAL = 'crucial',
  IMPORTANT = 'important',
}

export const possiblePhotographyPotentials = [
  PhotographyPotential.DONT_CARE,
  PhotographyPotential.IMPORTANT,
  PhotographyPotential.CRUCIAL,
]

export enum PhoneSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const possiblePhoneSizes = [PhoneSize.SMALL, PhoneSize.MEDIUM, PhoneSize.LARGE]

export interface PhoneSpecs {
  position: number
  slug: string
  name: string
  osName: string
  osSlug: string
  brandSlug: string
  brandName: string
  photography: null | PhotographyPotential
  size: null | PhoneSize
  monthly: number
  modelId: number
  modelSlug: string
  modelMemorySize: number
  modelMemorySlug: string
  modelMemoryName: string
  modelPrice: number
}
